<!-- 组织机构管理-->

<template>
  <div class="c-profile-content">
    <ul class="c-profile-lsit">
      <li class="c-profile-lsit-li" v-for="(item,index) in rlist" :key="index">
        <img src="../../assets/main/news-icon01.png">
        <div class="c-profile-center-box">
          <h3>{{item.title}}</h3>
          <p>{{item.projectdetail}}</p>
          <div class="c-btn-box">
            <a href="javascrip:;">{{item.projecttype?'产品':'服务'}}</a>
            <a href="javascrip:;" v-if="item.industrycategory">{{item.industrycategory}}</a>
            <a href="javascrip:;">{{item.projectcategory}}</a>
          </div>
          <div class="c-btn-box-contact" v-if="item.checked==2">
            <p>{{'联系人:'+item.contacts}}</p>
            <p>{{'手机号:'+item.mobile}}</p>
          </div>
        </div>
        <div class="c-profile-right-box">
          <a href="javascrip:;">{{item.status}}</a>

          <!-- <p>北京通州</p> -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {
    myprojectsignupelist
  } from '@/api/project.js'
  export default {

    name: 'PublishProject',
    props: {},
    components: {},
    data() {
      return {
        rlist: []
      }
    },
    computed: {},
    mounted() {
      this.queryList()
    },
    methods: {
      queryList() {
        this.$http.get(myprojectsignupelist()).then((res) => {
          console.log(res);
          if (res.code === 1) {
            var list = res.data
            for (var i = 0; i < list.length; i++) {
              var item = list[i]
              if(item.imgs){
                var img = JSON.parse(item.imgs)[0]
                item.imgs = `${config.HOST_IMG}${img}`
              }
              if(item.checked==0){
                item.status="正在匹配"
              }else if(item.checked==2){
                item.status="匹配成功"
              }else{
                item.status="未匹配成功"
              }
              this.rlist.push(item)
            }
          }
        });
      },
    }
  }
</script>

<style>
  @import url(./publishproject.css);
</style>
